import { useState } from 'react';
import { FormViewController } from './formViewInterface';

export function createFormController(): FormViewController {
    return {
        useProps(props) {
            const [error, setError] = useState<null | Error>(null);
            const { isSubmitting } = props.form.formState;
            return {
                form: props.form,
                alert: error
                    ? {
                          status: 'error',
                          label: error.message,
                      }
                    : null,
                getFormElementProps() {
                    return {
                        onSubmit: props.form.handleSubmit(async (values) => {
                            try {
                                const response = await props.onSubmit(values);
                            } catch (error) {
                                if (error instanceof Error) {
                                    console.error(error);
                                    setError(error);
                                    return;
                                }
                                throw error;
                            }
                        }, props.onError),
                    };
                },
                getSubmitButtonProps() {
                    return {
                        type: 'submit',
                        isLoading: isSubmitting,
                        isDisabled: isSubmitting,
                    };
                },
            };
        },
    };
}
